// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"2c5c958b","846":"0d39b1e0","906":"a09050a1"}[chunkId] + ".chunk.js";
};